var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0891 3.11987L15.3446 9.61454L16.9617 5.78277L24.0891 3.11987Z",
    fill: "#E2761B",
    stroke: "#E2761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90207 3.11987L12.5763 9.67606L11.0383 5.78277L3.90207 3.11987Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9429 18.1746L18.6139 21.7427L23.597 23.1137L25.0295 18.2537L20.9429 18.1746Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.97928 18.2537L4.40301 23.1137L9.38606 21.7427L7.05712 18.1746L2.97928 18.2537Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10482 12.1455L7.71625 14.246L12.6641 14.4657L12.4884 9.14868L9.10482 12.1455Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8864 12.1455L15.4589 9.08716L15.3446 14.4657L20.2837 14.246L18.8864 12.1455Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38605 21.7427L12.3565 20.2926L9.79032 18.2888L9.38605 21.7427Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6346 20.2926L18.6139 21.7427L18.2009 18.2888L15.6346 20.2926Z",
    fill: "#E4761B",
    stroke: "#E4761B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.614 21.7426L15.6347 20.2925L15.872 22.2347L15.8456 23.0521L18.614 21.7426Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38608 21.7426L12.1544 23.0521L12.1369 22.2347L12.3566 20.2925L9.38608 21.7426Z",
    fill: "#D7C1B3",
    stroke: "#D7C1B3",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1984 17.0058L9.72003 16.2763L11.4689 15.4766L12.1984 17.0058Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7928 17.0058L16.5223 15.4766L18.28 16.2763L15.7928 17.0058Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38607 21.7427L9.80791 18.1746L7.05713 18.2537L9.38607 21.7427Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1921 18.1746L18.6139 21.7427L20.9429 18.2537L18.1921 18.1746Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2837 14.2461L15.3446 14.4658L15.8016 17.0057L16.5311 15.4765L18.2888 16.2762L20.2837 14.2461Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72001 16.2762L11.4777 15.4765L12.1984 17.0057L12.6641 14.4658L7.71625 14.2461L9.72001 16.2762Z",
    fill: "#CD6116",
    stroke: "#CD6116",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71625 14.2461L9.79032 18.2888L9.72001 16.2762L7.71625 14.2461Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2888 16.2762L18.2009 18.2888L20.2837 14.2461L18.2888 16.2762Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6642 14.4658L12.1984 17.0057L12.7784 20.0025L12.9102 16.0565L12.6642 14.4658Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3446 14.4658L15.1073 16.0477L15.2128 20.0025L15.8016 17.0057L15.3446 14.4658Z",
    fill: "#E4751F",
    stroke: "#E4751F",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8016 17.0056L15.2128 20.0024L15.6346 20.2924L18.2009 18.2887L18.2888 16.2761L15.8016 17.0056Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72003 16.2761L9.79034 18.2887L12.3566 20.2924L12.7784 20.0024L12.1984 17.0056L9.72003 16.2761Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8456 23.0522L15.872 22.2348L15.6522 22.0415H12.339L12.1369 22.2348L12.1544 23.0522L9.38608 21.7427L10.3528 22.5336L12.3126 23.8958H15.6786L17.6472 22.5336L18.6139 21.7427L15.8456 23.0522Z",
    fill: "#C0AD9E",
    stroke: "#C0AD9E",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6346 20.2925L15.2128 20.0024H12.7784L12.3566 20.2925L12.1368 22.2347L12.339 22.0414H15.6522L15.8719 22.2347L15.6346 20.2925Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4583 10.0364L25.2053 6.4507L24.0892 3.11987L15.6347 9.39483L18.8864 12.1456L23.4828 13.4902L24.5022 12.3038L24.0628 11.9874L24.7659 11.3459L24.221 10.924L24.9241 10.3879L24.4583 10.0364Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.79474 6.4507L3.54176 10.0364L3.06718 10.3879L3.77026 10.924L3.23416 11.3459L3.93724 11.9874L3.49781 12.3038L4.50849 13.4902L9.10485 12.1456L12.3566 9.39483L3.90208 3.11987L2.79474 6.4507Z",
    fill: "#763D16",
    stroke: "#763D16",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4827 13.4904L18.8864 12.1458L20.2837 14.2462L18.2009 18.2889L20.9429 18.2537H25.0295L23.4827 13.4904Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10483 12.1458L4.50847 13.4904L2.97928 18.2537H7.05712L9.79033 18.2889L7.71625 14.2462L9.10483 12.1458Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3446 14.4657L15.6347 9.39477L16.9705 5.78271H11.0383L12.3566 9.39477L12.6642 14.4657L12.7696 16.0652L12.7784 20.0024H15.2128L15.2304 16.0652L15.3446 14.4657Z",
    fill: "#F6851B",
    stroke: "#F6851B",
    strokeWidth: 0.0878845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskIcon);
export default __webpack_public_path__ + "static/media/MetamaskIcon.b25f53ec.svg";
export { ForwardRef as ReactComponent };